import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=e43ffebc&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e43ffebc')) {
      api.createRecord('e43ffebc', component.options)
    } else {
      api.reload('e43ffebc', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=e43ffebc&", function () {
      api.rerender('e43ffebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/lib/vue/components/modules/Pagination.vue"
export default component.exports